export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-primary-700">今日大瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              每天一分钟看懂热搜话题。今日大瓜致力于把碎片化的讨论整理成“讲的是谁、因何被议论、焦点在哪、最新进展”的简明解读，陪你理性吃瓜、不传谣不造谣。
            </p>
            <p className="mt-5 text-sm text-foreground-600">
              联系邮箱：
              <a href="mailto:hello@jinridagua.example" className="whitespace-nowrap text-primary-700 hover:underline">
                hello@jinridagua.example
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li><a className="hover:text-primary-700 hover:underline" href="#focus">今日焦点</a></li>
              <li><a className="hover:text-primary-700 hover:underline" href="#track">瓜分赛道</a></li>
              <li><a className="hover:text-primary-700 hover:underline" href="#rank">热门瓜榜</a></li>
              <li><a className="hover:text-primary-700 hover:underline" href="#latest">最新瓜闻</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900">更多内容</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li><a className="hover:text-primary-700 hover:underline" href="#learn">吃瓜小课堂</a></li>
              <li><a className="hover:text-primary-700 hover:underline" href="#about">关于我们</a></li>
              <li><a className="hover:text-primary-700 hover:underline" href="#join">订阅瓜报</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 今日大瓜 · 理性吃瓜，从看懂一个热搜开始。内容均为公开讨论的客观转述，不构成任何事实认定。
          </p>
          <div className="flex items-center gap-3">
            <a href="#home" aria-label="回到顶部" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200/70 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </a>
            <a href="https://weibo.example" aria-label="微博（示例外链）" rel="nofollow noopener" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200/70 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
              <i className="ri-weibo-line" aria-hidden="true"></i>
            </a>
            <a href="https://wechat.example" aria-label="微信公众号（示例外链）" rel="nofollow noopener" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200/70 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
              <i className="ri-wechat-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}